<template>
  <div>
    <div class="container" :class="group">
      <div class="row">
        <div class="col col-4">
          <div class="col col-10">
            <h2 :class="group === 'businessupgrade' ? 'h5' : 'h3'" class="h3">
              {{ titleSubtitle[0] }}
            </h2>
            <p v-if="group !== 'businessupgrade' || (group === 'businessupgrade' && $store.state.layout === 'mobile')" class="body-1">
              {{ titleSubtitle[1] }}
              <nuxt-link v-if="$config.project === 'site'" to="/support/">
                Help Center
              </nuxt-link>
              <a v-else :href="`${$config.siteUrl}/support/`">
                Help Center
              </a>
              page or
              <nuxt-link v-if="$config.project === 'site'" to="/contact-us/">
                contact us
              </nuxt-link>
              <a v-else :href="`${$config.siteUrl}/contact-us/`">
                contact us
              </a>
              directly.
            </p>
          </div>
        </div>
        <div class="col col-8">
          <div
            class="faq-section"
          >
            <div class="section-inner">
              <div class="questions-wrap">
                <div
                  v-for="(item, i) in questions"
                  :key="i"
                  class="question"
                  :class="{ open: item.opened, hidden: !showAll && i > 3 }"
                >
                  <span
                    class="question-text"
                    @click="$set(questions[i], 'opened', !questions[i].opened)"
                  >
                    {{ item.question }}
                    <IconExpand class="arrow" />
                  </span>
                  <div class="answer body-2" v-html="item.answer" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconExpand from './assets/svg/icon-faq-expand.svg?vue-component';

export default {
  components: { IconExpand },
  props: {
    whiteBackground: { type: Boolean },
    group: { type: String, default: 'certificates' },
    results: { type: Array, default: () => [] },
  },
  data() {
    return {
      showAll: this.group === 'pricing' || this.group === 'all' || this.group === 'businessupgrade' || this.group === 'business' || this.group === 'leaderboard' || this.group === 'certificates' || this.group === 'projects' || this.group === 'decks',
      certificates: [],
      pricing: [],
      businessupgrade: [],
      livetraining: [],
    };
  },
  async fetch() {
    if (this.group !== 'all' && !this.results.length) {
      this[this.group] = await this.$axios.$get(`/faq/groups/${this.group}`);
    }
  },
  computed: {
    questions() {
      return this.results.length ? this.results : this[this.group];
    },
    titleSubtitle() {
      return this.group !== 'decks'
        ? [this.$c.text('component.faq.title'), this.$c.text('component.faq.subtitle')]
        : ['Frequently Asked Questions', 'Can’t find what you\'re looking for? Visit the 365 Data Science'];
    },
  },
};
</script>
<style scoped lang="scss">
.decks {
  .faq-section .section-inner .questions-wrap .question .answer {
    ::v-deep {
      .not-well span,
      .not-sure span,
      .very-well span {
        color: var(--main-light);
        font-weight: 600;
        line-height: 150%;
        border-radius: 6px;
        padding: 3px var(--spacing-6) 2px var(--spacing-6);
      }

      .not-well span {
        background: var(--main-red);
      }

      .not-sure span {
        background: var(--main-dark-light-4);
      }

      .very-well span {
        background: var(--accent);
      }

      .not-well-2 span,
      .not-sure-2 span,
      .very-well-2 span {
        font-weight: 700;
      }

      .not-well-2 span {
        color: var(--main-red);
      }

      .not-sure-2 span {
        color: var(--main-dark-light-4);
      }

      .very-well-2 span {
        color: var(--accent);
      }

      .numbers-outside {
        padding-left: 23px;
        list-style-position: outside;

        li {
          margin-bottom: 10px;

          &::marker {
            font-weight: 700;
          }
        }
      }

      img {
        max-width: 100%;
      }
    }
  }
}

.faq-section {
  .section-inner {
    .section-title {
      text-align: center;
      color: #006870;
    }

    .questions-wrap {
      .question {
        border-top: 1px solid var(--lighter-gray);
        box-sizing: border-box;
        color: var(--main-dark-shade-0);
        display: grid;
        overflow: hidden;
        position: relative;
        transition: all 200ms ease-in-out;

        &:first-of-type {
          border-color: transparent;
        }

        &.hidden {
          border-top-width: 0;

          .question-text {
            height: 0;
            padding-top: 0;
            padding-bottom: 0;
          }
        }

        .question-text {
          display: block;
          padding: var(--spacing-24) 35px var(--spacing-24) 0;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 250ms ease-in-out;
          position: relative;

          .arrow {
            position: absolute;
            right: 0;
            top: var(--spacing-24);
            transition: all 250ms ease-in-out;
          }
        }

        &.open:not(.hidden) {
          .question-text .arrow {
            transform: rotateZ(90deg);
          }

          .answer {
            color: var(--main-dark-light-3);
            max-height: 9999px;
            transition: max-height 1s ease-in-out;
            overflow: hidden;
          }
        }

        .answer {
          color: var(--main-dark-light-3);
          max-height: 0;
          transition: all 500ms cubic-bezier(0, 1, 0, 1);

          a {
            color: var(--accent);
          }
        }
      }
    }
  }
}

.businessupgrade {
  .col-8 {
    margin-top: -24px;

    .faq-section {
      .section-inner {
        .questions-wrap {
          .question {
            color: var(--main-light);
            border-top: 1px solid rgba(255, 255, 255, 0.12);

            .question-text {
              svg {
                top: var(--spacing-28);

                path[stroke] {
                  stroke: var(--main-light);
                }
              }
            }

            .answer {
              font-weight: 500;
              font-size: 14px;
              line-height: 23px;
              color: var(--main-dark-shade-4);
            }

            &:first-of-type {
              border-color: transparent;
            }

            &:last-of-type {
              border-bottom: 1px solid rgba(255, 255, 255, 0.12);
            }
          }
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .h3 {
    font-size: 24px;
    line-height: 30px;
  }

  .body-1 {
    font-size: 16px;
    line-height: 26px;
  }
}

@include bp($bp-phone) {
  .businessupgrade {
    padding: 0;

    h2 {
      font-weight: 500;
      font-size: 32px;
      line-height: 110%;
    }

    .body-1 {
      font-size: 18px;
      margin: 0;

      a {
        color: var(--accent);
      }
    }

    .col-8 {
      margin-top: 66px;

      .faq-section .section-inner .questions-wrap .question {
        &.open {
          .question-text {
            padding-bottom: 0;
          }
        }
      }
    }
  }

  .col {
    padding-left: 0;
    padding-right: 0;
  }

  .row {
    margin-right: 0;
    margin-left: 0;
  }

  .decks {
    .faq-section .section-inner .questions-wrap .question .answer {
      ::v-deep {
        img {
          height: 243px;
        }
      }
    }
  }
}
</style>
